import { createBrowserRouter } from "react-router";
import { BlogPage, PostPage } from "../features/blog";
import { ContactPage } from "../features/contact";
import { HomePage } from "../features/hero";
import { PrivacyPage } from "../features/privacy";
import { UpdatesPage } from "../features/updates";
import { ShopPage, ListingPage } from "../features/shop";
import { NotFoundPage } from "./NotFoundPage";
import { RouteErrorPage } from "./RouteErrorPage";
import { routePatterns } from "./routes";
import { SiteLayout } from "./SiteLayout";

export const router = createBrowserRouter([
  {
    element: <SiteLayout />,
    errorElement: <RouteErrorPage />,
    children: [
      { path: routePatterns.home, element: <HomePage /> },
      { path: routePatterns.blog, element: <BlogPage /> },
      { path: routePatterns.post, element: <PostPage /> },
      { path: routePatterns.updates, element: <UpdatesPage /> },
      { path: routePatterns.shop, element: <ShopPage /> },
      { path: routePatterns.listing, element: <ListingPage /> },
      { path: routePatterns.contact, element: <ContactPage /> },
      { path: routePatterns.privacy, element: <PrivacyPage /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
